import { PaginationResponse } from './../responses/PaginationResponse';
import { UpvestOrderTransaction } from '../models';
import { HttpHeader } from '../utils/HttpHeader';
import { HttpRequester } from '../utils/HttpRequester';
import { Urls } from "../utils/Urls";
import { TokenService } from './TokenService';
export class UpvestOrderTransactionService {
    private static links = Urls.URLS();
    private static requester = HttpRequester.httpRequester();
    private static headers = new HttpHeader();
    constructor() {
        // Initialization code here
    }

    // Add methods for the service here
    public static async getUpvestOrderTransactions(upvestAccountId:string,page:number,per_page:number): Promise<PaginationResponse<UpvestOrderTransaction>> {        
        try {
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getUpvestOrderTransactions(upvestAccountId,page,per_page), this.headers);
            let response:PaginationResponse<UpvestOrderTransaction> = {
                        data:json.data,
                        currentPage:json.meta.current_page,
                        lastPage:json.meta.last_page,
                        total:json.meta.total
                    };
            return response;
        }
        catch (err) {
            throw err;
        }
    }
}